export default __webpack_public_path__ + "static/media/HelveticaNeueMedium.980f3558.woff";